export const FETCH_ALL_GUARDIANS = 'FETCH_ALL_GUARDIANS';
export const CREATE_GUARDIAN = 'CREATE_GUARDIAN';
export const PATCH_GUARDIAN = 'PATCH_GUARDIAN';
export const DELETE_GUARDIAN = 'DELETE_GUARDIAN';
export const GET_GUARDIAN = 'GET_GUARDIAN';